import { errorWrapper } from 'utility/error';

import { apiClient } from './api';
import { toPredictionDomain } from './transformers/toPredictionDomain';

// Fetches all user predictions for a tenant and maps them onto the `Data.Projection` domain.
// `zoneId: null` and `dates: null` return the full history across all zones; selectors slice downstream.
async function getPredictions(args: { tenantId: string }) {
  const { tenantId } = args;

  const apiCall = apiClient.Prediction_Search(
    { zoneId: null, subZoneId: null, dates: null },
    { params: { tenantId } },
  );

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to load predictions',
    },
    onSuccess: (dtos) => {
      const { forecastDomain } = toPredictionDomain({ dtos: dtos ?? [] });
      return { forecastDomain };
    },
  });
}

export { getPredictions };
